import React from 'react';

function User(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M9 7.25C9 8.90685 10.3431 10.25 12 10.25C13.6569 10.25 15 8.90685 15 7.25C15 5.59315 13.6569 4.25 12 4.25C10.3431 4.25 9 5.59315 9 7.25ZM12 3C9.65279 3 7.75 4.90279 7.75 7.25C7.75 9.59721 9.65279 11.5 12 11.5C14.3472 11.5 16.25 9.59721 16.25 7.25C16.25 4.90279 14.3472 3 12 3Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M5.42027 18.1158C5.30914 18.2872 5.25 18.4872 5.25 18.6915C5.25 19.2761 5.72391 19.75 6.30851 19.75H17.7113L17.8451 19.7445C18.0113 19.7274 18.1717 19.6712 18.3128 19.5797C18.8016 19.2629 18.9423 18.6111 18.6288 18.1211L18.4449 17.8451C16.7625 15.3937 14.6481 14.2608 12.0228 14.2608C9.31032 14.2608 7.13401 15.4717 5.42027 18.1158ZM19.4805 17.145C17.5867 14.3817 15.1008 13.0108 12.0228 13.0108C8.8386 13.0108 6.28811 14.4786 4.37134 17.4359C4.12897 17.8098 4 18.2459 4 18.6915C4 19.9664 5.03355 21 6.30851 21H17.7371L17.9273 20.9921C18.306 20.9608 18.6722 20.8364 18.9927 20.6287C20.0626 19.9352 20.3677 18.5057 19.6742 17.4359L19.4805 17.145Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default User;
